import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CloneService } from 'src/app/services/clone.service';
import { DoorWidthReductionValue, DoorWidthReduction } from 'src/app/models/DoorWidthReduction.model';
import { Standback } from 'src/app/models/Standback.model';
import { DoorWidthReal } from 'src/app/models/DoorWidthReal.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { DoorWidthAndPhysicalSeparationFactorValue, DoorWidthAndPhysicalSeparationFactor } from 'src/app/models/DoorWidthAndPhysicalSeparationFactor.model';
import { DoorWidthCalculated } from 'src/app/models/DoorWidthCalculated.model.';
import { factorSetSeperationNaming } from 'src/app/models/FactorSet.model';
import { DoorWidthAndPhysicalSeparationFactorData } from './DoorWidthAndPhysicalSeparationFactorData.model';

@Component({
  selector: 'app-door-width-and-physical-separation-factor',
  templateUrl: './door-width-and-physical-separation-factor.component.html',
  styleUrls: ['./door-width-and-physical-separation-factor.component.scss']
})
export class DoorWidthAndPhysicalSeparationFactorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('doorWidthAndPhysicalSeparationFactor', this._formBuilder.array([]));
    this.form.setControl('doorWidthAndPhysicalSeparationFactor', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('doorWidthAndPhysicalSeparationFactor');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as DoorWidthAndPhysicalSeparationFactorValue[];
     this.gridData=this.ConvertData();

  }
  asFormGroup(o: DoorWidthAndPhysicalSeparationFactor): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: DoorWidthAndPhysicalSeparationFactor;
  @Input('rowHeaders') rowHeaders: DoorWidthCalculated[];
  @Input('isEditable') isEditable: boolean;
  gridData: GridData=new GridData();
  form: FormGroup;
  lascCtrl;
  matrix:DoorWidthAndPhysicalSeparationFactorData[]=[];
  ConvertData(): GridData {
    for (let i = 0; i < this.data.values.length; i++) {
      const element = this.data.values[i];
      let DoorWidthAndPhysicalSeparationFactorData1:DoorWidthAndPhysicalSeparationFactorData = new DoorWidthAndPhysicalSeparationFactorData;
      DoorWidthAndPhysicalSeparationFactorData1.colId=1;
      DoorWidthAndPhysicalSeparationFactorData1.value=element.noSeparationValue;
      DoorWidthAndPhysicalSeparationFactorData1.doorWidthCalculatedId=element.doorWidthCalculatedId;
      this.matrix.push(DoorWidthAndPhysicalSeparationFactorData1);

      let DoorWidthAndPhysicalSeparationFactorData2:DoorWidthAndPhysicalSeparationFactorData = new DoorWidthAndPhysicalSeparationFactorData;
      DoorWidthAndPhysicalSeparationFactorData2.colId=2;
      DoorWidthAndPhysicalSeparationFactorData2.value=element.oneSeparationValue;
      DoorWidthAndPhysicalSeparationFactorData2.doorWidthCalculatedId=element.doorWidthCalculatedId;
      this.matrix.push(DoorWidthAndPhysicalSeparationFactorData2);

      let DoorWidthAndPhysicalSeparationFactorData3:DoorWidthAndPhysicalSeparationFactorData = new DoorWidthAndPhysicalSeparationFactorData;
      DoorWidthAndPhysicalSeparationFactorData3.colId=3;
      DoorWidthAndPhysicalSeparationFactorData3.value=element.twoSeparationsValue;
      DoorWidthAndPhysicalSeparationFactorData3.doorWidthCalculatedId=element.doorWidthCalculatedId;
      this.matrix.push(DoorWidthAndPhysicalSeparationFactorData3);
    }
    
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < factorSetSeperationNaming.length; i++) {
      const headerEntry = factorSetSeperationNaming[i];
      colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix.sort((a, b) => a.colId - b.colId);
    grid.colProp = 'colId';
    grid.rowProp = 'doorWidthCalculatedId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalize(data: DoorWidthAndPhysicalSeparationFactorData[]) {
    let tmp:DoorWidthAndPhysicalSeparationFactorValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const element = this.rowHeaders[i];
      let tmpData:DoorWidthAndPhysicalSeparationFactorValue = new DoorWidthAndPhysicalSeparationFactorValue;
        for (let i = 0; i < data.length; i++) {
          const element2 = data[i];
          if(element2.doorWidthCalculatedId==element.id)
          {
            tmpData.doorWidthCalculatedId=element2.doorWidthCalculatedId;
            if(element2.colId==1)
            {
              tmpData.noSeparationValue=element2.value;
            }
            else if(element2.colId==2)
            {
              tmpData.oneSeparationValue=element2.value;
            }
            else if(element2.colId==3)
            {
              tmpData.twoSeparationsValue=element2.value;
            }
          }
      }
      tmp.push(tmpData);
    }
    this.data.values=tmp;
  }
  save()
  {
   
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as DoorWidthAndPhysicalSeparationFactorData[];
    this.normalize(clonedGridData);

    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
